import InfoLayout from "./InfoLayout";

function License() {
    return (
        <InfoLayout title="License Terms">
  <div>
    <h2>1. Ownership</h2>
    <p>
      The <strong>Tabata Timer</strong> application is the exclusive property of
      <a
        href="https://www.tabataworkout.online"
        target="_blank"
        rel="noopener noreferrer"
      >
        {" "}
        www.tabataworkout.online
      </a>
      . All content of the application, including code, design, text, and
      multimedia elements, belongs to the operator and is protected by copyright
      law.
    </p>

    <h2>2. Use of the Application</h2>
    <p>
      The application is provided free of charge and is intended for use via a
      web browser. We do not provide installation files – the application runs
      directly online. The user is granted a non-exclusive, non-transferable
      license to use the application for personal and non-commercial purposes.
    </p>
    <p>
      The freemium version may contain advertisements. Using the application for
      illegal or harmful purposes is strictly prohibited. You may share the
      application with others via a link, recommend it to other users, or
      promote it.
    </p>

    <h2>3. Restrictions</h2>
    <ul>
      <li>
        You may not copy, distribute, sell, or otherwise commercially exploit
        the application without the operator’s written consent.
      </li>
      <li>
        You may not attempt to reverse engineer, modify, or otherwise access the
        application’s source code.
      </li>
      <li>
        You may not remove or alter any protective notices, logos, or copyright
        information.
      </li>
    </ul>

    <h2>4. Liability</h2>
    <p>
      The application is provided “as is,” and the operator assumes no liability
      for any damages, data loss, or other issues resulting from the use of the
      application. By using the application, the user acknowledges and accepts
      these risks.
    </p>

    <h2>5. Updates and Changes</h2>
    <p>
      The operator reserves the right to update the application at any time,
      modify its features, or discontinue its availability without prior notice.
      We recommend reviewing the current version of the license terms regularly.
    </p>

    <h2>6. Contact</h2>
    <p>
      If you have any questions regarding the license terms, you can contact us
      at: <strong>admin@tabataworkout.online</strong>. We will be happy to
      answer your questions or provide the necessary support.
    </p>

    <p>
      By using this application, you confirm that you have read and agree to the
      above license terms.
    </p>
  </div>
</InfoLayout>

    );
}

export default License;
